import { render } from "./ButtonSection.vue?vue&type=template&id=4f56aca9&scoped=true"
import script from "./ButtonSection.vue?vue&type=script&lang=js"
export * from "./ButtonSection.vue?vue&type=script&lang=js"

import "./ButtonSection.vue?vue&type=style&index=0&id=4f56aca9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f56aca9"]])

export default __exports__